import {useNavigate} from 'react-router-dom';
import {Alert, AlertDescription} from '@/components/ui/alert.tsx';
import {Button} from '@/components/ui/button.tsx';
import {Empty, EmptyDescription, EmptyHeader, EmptyTitle} from '@/components/ui/empty.tsx';
import {Skeleton} from '@/components/ui/skeleton.tsx';
import {ProductSkuCombobox} from '../../../components/product-sku-combobox';
import {PeriodPicker} from '../../../components/period-picker/period-picker';
import {SalesDynamicsChart} from './sales-dynamics-chart';
import {SalesDynamicsSummary} from './sales-dynamics-summary';
import {useSalesDynamicsPage} from './use-sales-dynamics-page';
import {cn} from 'cn';
import {pageContentClassName} from '../../../ui/pageContentClass';

export function SalesDynamicsPage() {
	const navigate = useNavigate();
	const state = useSalesDynamicsPage();

	return (
		<div className={cn(pageContentClassName, 'flex flex-col gap-4')}>
			<div className="flex items-center justify-between gap-3">
				<h1 className="text-xl font-semibold tracking-tight">Динамика продаж</h1>
				<Button type="button" variant="ghost" size="sm" onClick={() => navigate('/ozon')}>
					Назад
				</Button>
			</div>

			<ProductSkuCombobox
				id="sales-dynamics-sku"
				label="Товар"
				catalog={state.products ?? []}
				value={state.sku}
				onValueChange={(next) => state.setSku(next)}
				disabled={state.products == null}
				filterItem={(item) => Boolean(item.ozonSku)}
				valueKey="ozonSku"
			/>

			<PeriodPicker {...state.period} dateFieldIdPrefix="sales-dynamics" />

			{state.error && (
				<Alert variant="destructive">
					<AlertDescription>{state.error}</AlertDescription>
				</Alert>
			)}
			{state.products != null && state.products.length === 0 && !state.error && (
				<Empty className="border border-border">
					<EmptyHeader>
						<EmptyTitle>Нет товаров</EmptyTitle>
						<EmptyDescription>В каталоге нет товаров со SKU</EmptyDescription>
					</EmptyHeader>
				</Empty>
			)}
			{!state.sku && state.products != null && state.products.length > 0 && (
				<Empty className="border border-border">
					<EmptyHeader>
						<EmptyTitle>Выберите товар</EmptyTitle>
						<EmptyDescription>График покажет продажи, доставки, возвраты и остаток за период</EmptyDescription>
					</EmptyHeader>
				</Empty>
			)}
			{state.loading && <Skeleton className="h-72 w-full"/>}
			{!state.loading && state.row && (
				<div className="flex flex-col gap-4">
					<SalesDynamicsSummary summary={state.row.summary}/>
					<SalesDynamicsChart statistics={state.row.statistics}/>
					{state.row.warnings.map((warning) => (
						<p key={warning} className="text-sm text-muted-foreground">{warning}</p>
					))}
				</div>
			)}
		</div>
	);
}
